<template>
    <div class="form">
        <h4 class="step-title">
            What is the primary purpose of your vehicle?
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <button-list v-bind:items="primaryUseTypes" v-bind:onclick="complete"/>
        </div>
    </div>
</template>

<script>
    import ButtonList from "./shared/ButtonList.vue"

    export default {
        name: "VehiclePrimaryUseType",
        components: {
            ButtonList
        },
        data: function() {
            return {
                primaryUseTypes: [
                    { text: "Commuting", value: "CommuteWork" },
                    { text: "Business/Commercial", value: "Business" },
                    { text: "Personal/Pleasure", value: "Pleasure" }
                ]
            }
        },
        props: {
            lead: Object
        },
        computed: {
            vehicle: function() {
                return this.lead.vehicles[this.lead.vehicles.length-1];
            }
        },
        methods: {
            complete: function(vehiclePrimaryUseType) {
                this.vehicle.primaryUseType = vehiclePrimaryUseType;
                this.$emit("complete", this.$options.name, this.vehicle.primaryUseType);
            }
        }
    }
</script>
